<div class="flex w-full flex-row flex-wrap items-center gap-x-4 gap-y-2 p-2">
  <div *ngFor="let resource of resources" class="flex items-center gap-2">
    <img [src]="resource | objectImage" class="h-6 w-6 shrink-0 object-contain" alt="">
    <span class="whitespace-nowrap text-sm">{{resource.labels | txtTranslate}}</span>
    <input nbInput class="form-control w-20" type="number" filled status="primary" placeholder="Qty"
      [(ngModel)]="resourceQuantities[resource.id]" [ngModelOptions]="{standalone: true}">
  </div>
</div>
